<script setup>
import Jumbo from '@/components/Docs/Jumbo.vue'
import DocSection from '@/components/Docs/Section.vue'
import CodeBlock from '@/components/Docs/CodeBlock.vue'
import JsonBlock from '@/components/Docs/JsonBlock.vue'

</script>

<template>
  <div class="wrap row">
    <jumbo title="Ip address">
    IP addresses, short for Internet Protocol addresses, are numerical labels assigned to devices connected to a network that utilize the Internet Protocol for communication. These addresses serve as unique identifiers, allowing devices to send and receive data within a network and across the internet. IP addresses are crucial in enabling devices to locate and communicate with each other effectively<br/><br>
Security professionals leverage IP addresses to monitor network traffic, detect anomalies, and identify potential threats. By analyzing IP addresses associated with malicious activities such as hacking attempts, malware distribution, or phishing schemes, security teams can strengthen defenses and respond proactively to emerging threats. Additionally, IP addresses are essential for threat intelligence, aiding in the identification, classification, and tracking of cyber threats. Through comprehensive analysis of IP address data, organizations can enhance their understanding of potential risks, enabling them to implement targeted security measures and mitigate cyber threats effectively.
    </jumbo>

    <doc-section title="Info">
      <template v-slot:left>
        This endpoint returns a collection of general information on an IP address. <br><br>
      </template>

      <template v-slot:right>
        <code-block title="/query/ip/:ip" method="GET">
          curl -X GET "https://api.webscout.io/query/ip/&lt;IP&gt;?apikey=&lt;APIKEY&gt;"
        </code-block>

        <json-block title="Response">
{"status":"success","data":{"ip":"89.36.76.126","location":{"country_iso":"RO"},"operator":"Surfshark VPN","network_type":"Cloud","network_provider":"M247","network_provider_services":["Backup/Recovery","Business Internet","Cloud","Colocation","Hosting","VPC"],"as_org":"M247 Europe SRL","asn":9009,"avg_ttl":0,"provider_description":"An internet service provider offering a range of services including broadband connectivity, data center solutions, and cloud services.","os_guess":""}}
        </json-block>
      </template>
    </doc-section>


  </div>
</template>

<style scoped>
.wrap {
  height: 100%;
  overflow-y: scroll;
  flex-direction: row;
}

.wrap > * {
  margin-top: 2.5rem;
}
.wrap > *:not(:first-child) {
  border-top: 2px solid #1e252f;
  padding-top: 2.5rem;
}
</style>
